import { useMemo } from 'react';
import {
  ConditionResourceLookup,
  useDeleteConditionResourceLookupMutation,
} from '../api';
import { useEntityActions, BaseEntityAction } from '@hooks/useEntityActions';

export type ConditionResourceAction = BaseEntityAction;

// Define getEntityId outside to ensure stability
const getEntityId = (resource: ConditionResourceLookup) => resource.id;

export const useConditionResourceActions = () => {
  const actions = useEntityActions<ConditionResourceLookup, ConditionResourceAction>({
    entityName: 'Condition Resource',
    displayProperty: 'title',
    deleteMutation: useDeleteConditionResourceLookupMutation,
    getEntityId,
  });

  return useMemo(() => actions, [actions]);
}; 